import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Error = () => {
return(
<div className="page-content thank_error">
    <section className="wi_full py_3 error_thank_sec" >
        <div className="container">
            <div className="row align-items-center flex-lg-row-reverse">
                <div className="col-lg-6 img_col">
                    <img src="./images/error.svg" alt="Error" />
                </div>
                <div className="col-lg-6 text_col">
                    <h1><span>Sorry, this page</span> could not be found</h1>
                    <p>Unfortunately, the page you are looking for does not exist, has been removed, or its name has changed.</p>
                    <div className="btn_block">
                        <Link to="/" className="button fill_btn">Back to Home</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
)
}